export default __webpack_public_path__ + "static/media/placeholder-gold-cover.d0fc8d7e.svg";